import { createRouter, createWebHistory } from 'vue-router';
import { getToken } from '@/util/auth';
import routerList from '@/util/router';

let routes = [
    {
        path: '/',
        component: () => import('@/Console'),
        children: routerList,
        meta: { requiresAuth: true }
    },
    {
        path: '/passport',
        component: () => import('@/Passport'),
        children: [
            {
                path: 'login',
                name: 'passportLogin',
                component: () => import('@/views/passport/login')
            }
        ]
    },
    { path: '/404', component: () => import('@/views/404') },
    { path: '/:pathMath(.*)*', redirect: '/404' }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

// 路由守卫：检查登录状态
router.beforeEach((to, from, next) => {
    const token = getToken();
    const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

    if (requiresAuth && !token) {
        // 需要认证但未登录，重定向到登录页
        next({
            path: '/passport/login',
            query: { redirect: to.fullPath }
        });
    } else if (to.path === '/passport/login' && token) {
        // 已登录且访问登录页，重定向到首页
        next({ path: '/' });
    } else {
        next();
    }
});

export default router;
